// services/functions/mintUnlockCode.ts — typed wrapper around the
// mintUnlockCode callable. Personal unlock codes (not tied to a
// license_org); used by customer support / refund flows to grant
// product entitlements to an individual user. Plaintext code is
// returned ONCE; the doc id is the SHA-256 of the code so reads
// from the unlock_codes collection are server-only.

import { httpsCallable } from 'firebase/functions';
import { functions } from '@/services/firebase';

interface Input {
  productIds: string[];
  maxUses: number;
  /** ISO 8601 timestamp; null = no expiry. */
  expiresAtIso: string | null;
  note: string | null;
}

interface Output {
  code: string;
  productIds: string[];
  maxUses: number;
  /** ISO 8601 timestamp; absent = no expiry. */
  expiresAt?: string;
}

const callable = httpsCallable<Input, Output>(functions, 'mintUnlockCode');

export async function mintUnlockCode(input: Input): Promise<Output> {
  const res = await callable(input);
  return res.data;
}
